import {Layout, Text} from "@ui-kitten/components";
import {View} from "react-native";
import {Feather} from "@expo/vector-icons";
import * as React from "react";
import {Bold} from "../../../shared/bold";
import {TransparentBox} from "../../../ui/transparent-box";

export const PricingExplain = () => <Layout level='2'
                                               style={{
                                                        backgroundColor: "transparent",
                                                        padding: 20
                                                    }}>
    <TransparentBox>
        <View style={{alignItems: "center"}}>
            <Feather name="package" size={50} color='#a0c946'/>
        </View>

        <Text style={{
            fontSize: 25,
            lineHeight: 25,
            marginTop: 10,
            marginBottom: 20,
            textAlign: "center",
            color: 'white'
        }}>Subscription Offer</Text>

        <View style={{flexDirection: "column"}}>
            <Text style={{color: 'white', lineHeight: 25, textAlign: 'center'}}><Text style={{color: '#a0c946', fontWeight: 'bold'}}>Supply of a wheelie bin</Text> and <Text style={{color: '#a0c946', fontWeight: 'bold'}}>two collection</Text> monthly upon request</Text>
        </View>
    </TransparentBox>
</Layout>;